import { useState } from 'react';
import { MapIconType } from '../pin/MapPin';
import { InfoWindow } from '@vis.gl/react-google-maps';
import mapIcon from '../icon/MapIcon';
import { WfUser } from 'src/api/wf/models/WfUser';
import Button from '../../button/Button';
import { useTranslation } from 'react-i18next';
import { useUserAgent } from 'src/common/userAgent/useUserAgent';
import { useWfUserStore } from 'src/api/wf/stores/WfUserStore';
import { formatJpnDate } from 'src/common/formatJpnDate/formatJpnDate';
import { WfSalesOfficeOption } from 'src/api/wf/stores/WfFilterStore';
import useWfWorkplaceService from 'src/api/wf/service/WfWorkplaceService';

export interface WF_UserMarkerProp {
  type: MapIconType;
  location: { latitude: number; longitude: number };
  user?: WfUser & { displayIndex?: number };
  canOpenPopup: boolean;
  popupOpened?: () => void;
  popupClosed?: () => void;
}

function WF_LocationMarker({
  type,
  location,
  user,
  canOpenPopup,
  popupOpened,
  popupClosed,
}: WF_UserMarkerProp) {
  const { t } = useTranslation();
  const { setSelectedUser } = useWfUserStore();
  const userAgent = useUserAgent();
  const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(false);
  const [salesOffice, setSalesOffice] = useState<WfSalesOfficeOption | undefined>(undefined);
  const { fetchSalesOffice } = useWfWorkplaceService();

  const handleSelection = () => {
    if (!user) return;
    setSelectedUser(user);
    setIsInfoWindowOpen(false);
  };

  if (!location || location.latitude == null || location.longitude == null) {
    return null;
  }

  const icon = mapIcon(type, user?.displayIndex, userAgent.isMobile);

  return (
    <>
      <div
        className="cursor-pointer"
        onClick={() => {
          if (canOpenPopup) {
            if (user?.branchCode) {
              fetchSalesOffice(user.branchCode, user.salesOfficeCode).then((office) => {
                setSalesOffice(office);
              });
            }

            setIsInfoWindowOpen(true);
            popupOpened?.();
          }
        }}
      >
        {icon}
      </div>

      {isInfoWindowOpen &&
        canOpenPopup &&
        (type === MapIconType.currentUserLocation ||
          type === MapIconType.worker ||
          type === MapIconType.workerMatch) && (
          <InfoWindow
            position={{ lat: location.latitude, lng: location.longitude }}
            onCloseClick={() => {
              setIsInfoWindowOpen(false);
              popupClosed?.();
            }}
          >
            <div className="flex min-w-[150px] flex-col gap-2 p-1 text-sm text-black">
              <label className="m-0 block break-words text-center font-bold">{user?.name}</label>
              <label className="m-0 text-center font-medium">{user?.telephoneNumber}</label>
              <label className="m-0 block break-words text-center font-medium">
                <span className="pr-1">{salesOffice?.code}</span>
                <span>{salesOffice?.name}</span>
              </label>
              <label className="m-0 text-center font-medium">
                {user?.locationUpdateDate ? formatJpnDate({ iso: user.locationUpdateDate }) : '-'}
              </label>
              {userAgent.isDesktop && (
                <Button
                  className="mt-1 rounded bg-blue-600 px-2 py-1 hover:bg-blue-700"
                  title={t('wf.markers.worker')}
                  onClick={handleSelection}
                />
              )}
            </div>
          </InfoWindow>
        )}
    </>
  );
}
export default WF_LocationMarker;
